// Text area field with a error message

import './TextArea.scss';

export default function TextArea({
  name,
  placeholder,
  // Above a filled field, where a call-to-action placeholder reads wrong
  label = placeholder,
  onChange,
  onBlur,
  value,
  rows,
  cols,
  maxLength,
  error,
}) {
  return (
    <div className='textarea'>
      <textarea
        className={error ? 'error' : ''}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        rows={rows}
        cols={cols}
        maxLength={maxLength}
      />
      <p className={'error-msg' + (error ? ' visible' : '')}>{error}</p>
      <p className={'label' + (value ? ' visible' : '')}>{label}</p>
    </div>
  );
}
